import {useMemo} from 'react';
import {useCurrentOrders} from '@views/Account/_hooks';

export const useCurrentBoxId = (): {boxId: string} => {
  const {inProgress} = useCurrentOrders();
  return useMemo(() => ({boxId: inProgress?.id || ''}), [inProgress]);
};
